import LoadingButton from '@mui/lab/LoadingButton';
import { useSnackbar } from 'notistack';
import { useEffect, useState } from 'react';
import server from '../../../global/server';
import useHandleErrors from '../../../hooks/useHandleErrors';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Stack,
    Typography,
} from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';

export default ({ data, mutate, close }) => {
    const { enqueueSnackbar } = useSnackbar();
    const [errs, setErrs] = useState();
    useHandleErrors(errs);

    const [approving, setApproving] = useState(false);
    const [denying, setDenying] = useState(false);
    const [confirmOpen, setConfirmOpen] = useState(false);
    const [approved, setApproved] = useState(false);

    useEffect(() => {
        if (data?.profile) {
            setApproved(data.profile.approved);
        }
    }, [data]);

    const handleApprove = async () => {
        try {
            setApproving(true);
            await server.patch(`/backoffice/${data.profile.id}/verify`);
            enqueueSnackbar('Anfitrião aprovado com sucesso!', { variant: 'success' });
            setApproving(false);
            mutate();
        } catch (error) {
            setApproving(false);
            setErrs(error);
        }
    };

    const handleDeny = async () => {
        try {
            setDenying(true);
            setConfirmOpen(false);
            await server.delete(`/backoffice/${data.profile.id}/deny`);
            enqueueSnackbar(
                approved
                    ? 'Anfitrião removido. Perfil e encontros apagados.'
                    : 'Anfitrião negado. Perfil e encontros removidos.',
                { variant: 'warning' },
            );
            setDenying(false);
            mutate();
            if (close) close();
        } catch (error) {
            setDenying(false);
            setErrs(error);
        }
    };

    if (!data?.profile) return null;

    return (
        <>
            <Stack direction="row" spacing={1}>
                <LoadingButton
                    onClick={handleApprove}
                    loading={approving}
                    variant={approved ? 'outlined' : 'contained'}
                    fullWidth
                    disabled={approved}
                    startIcon={approved ? <CheckCircleIcon /> : undefined}
                    sx={approved ? {
                        borderColor: '#2e7d32',
                        color: '#2e7d32',
                        '&.Mui-disabled': { borderColor: '#2e7d32', color: '#2e7d32', opacity: 0.8 },
                    } : {
                        bgcolor: '#006a61',
                        textTransform: 'none',
                        fontWeight: 600,
                        '&:hover': { bgcolor: '#005a52' },
                    }}
                >
                    {approved ? 'Aprovado' : 'Aprovar'}
                </LoadingButton>

                {/* Anfitriao ja aprovado tambem precisa poder ser removido: a
                    unica saida antes era negar antes da aprovacao */}
                <LoadingButton
                    onClick={() => setConfirmOpen(true)}
                    loading={denying}
                    variant="outlined"
                    fullWidth
                    startIcon={approved ? <DeleteOutlineIcon /> : undefined}
                    sx={{
                        borderColor: '#d32f2f',
                        color: '#d32f2f',
                        textTransform: 'none',
                        fontWeight: 600,
                        '&:hover': { borderColor: '#b71c1c', bgcolor: '#fff5f5' },
                    }}
                >
                    {approved ? 'Remover anfitrião' : 'Negar'}
                </LoadingButton>
            </Stack>

            <Dialog
                open={confirmOpen}
                onClose={() => setConfirmOpen(false)}
                PaperProps={{ sx: { borderRadius: '16px', maxWidth: 420 } }}
            >
                <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1, fontWeight: 600 }}>
                    <WarningAmberIcon sx={{ color: '#e65100' }} />
                    {approved ? 'Remover anfitrião' : 'Negar anfitrião'}
                </DialogTitle>
                <DialogContent>
                    <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.6 }}>
                        {approved ? 'Ao remover este anfitrião, ' : 'Ao negar este anfitrião, '}
                        o perfil de anfitrião será <strong>removido permanentemente</strong> e
                        todos os encontros criados por ele serão <strong>apagados</strong>. O usuário voltará a ser um Conviva.
                    </Typography>
                    <Typography variant="body2" color="text.secondary" sx={{ mt: 1.5, lineHeight: 1.6 }}>
                        Essa ação <strong>não pode ser desfeita</strong>. Deseja continuar?
                    </Typography>
                </DialogContent>
                <DialogActions sx={{ p: 2, gap: 1 }}>
                    <Button
                        onClick={() => setConfirmOpen(false)}
                        variant="outlined"
                        sx={{
                            textTransform: 'none',
                            borderColor: '#ccc',
                            color: '#666',
                            borderRadius: '8px',
                        }}
                    >
                        Cancelar
                    </Button>
                    <Button
                        onClick={handleDeny}
                        variant="contained"
                        sx={{
                            bgcolor: '#d32f2f',
                            textTransform: 'none',
                            fontWeight: 600,
                            borderRadius: '8px',
                            '&:hover': { bgcolor: '#b71c1c' },
                        }}
                    >
                        {approved ? 'Confirmar remoção' : 'Confirmar negação'}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};
